
import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function CategoryGrid() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation<HTMLDivElement>({ threshold: 0.2 });
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation<HTMLDivElement>({ threshold: 0.1 });

  const categories = [
    { 
      name: 'Gifts for Her', 
      icon: 'ri-heart-fill', 
      count: '127 gift ideas',
      color: 'from-[#8B2635] to-[#A52A3A]',
      bgColor: 'bg-gradient-to-br from-[#8B2635]/5 to-[#A52A3A]/10'
    },
    { 
      name: 'Gifts for Him', 
      icon: 'ri-user-smile-fill', 
      count: '143 gift ideas',
      color: 'from-[#1B4332] to-[#2D5F4C]',
      bgColor: 'bg-gradient-to-br from-[#1B4332]/5 to-[#2D5F4C]/10'
    },
    { 
      name: 'Kids & Teens', 
      icon: 'ri-bear-smile-fill', 
      count: '156 gift ideas',
      color: 'from-[#D4AF37] to-[#E5C158]',
      bgColor: 'bg-gradient-to-br from-[#D4AF37]/5 to-[#E5C158]/10'
    },
    { 
      name: 'Tech Lovers', 
      icon: 'ri-smartphone-fill', 
      count: '98 gift ideas',
      color: 'from-[#2D5F4C] to-[#1B4332]',
      bgColor: 'bg-gradient-to-br from-[#2D5F4C]/5 to-[#1B4332]/10'
    },
    { 
      name: 'Home & Living', 
      icon: 'ri-home-smile-fill', 
      count: '134 gift ideas',
      color: 'from-[#8B2635] to-[#A52A3A]',
      bgColor: 'bg-gradient-to-br from-[#8B2635]/5 to-[#A52A3A]/10'
    },
    { 
      name: 'Stocking Fillers', 
      icon: 'ri-gift-2-fill', 
      count: '89 gift ideas',
      color: 'from-[#D4AF37] to-[#E5C158]',
      bgColor: 'bg-gradient-to-br from-[#D4AF37]/5 to-[#E5C158]/10'
    },
    { 
      name: 'Budget Finds', 
      icon: 'ri-price-tag-3-fill', 
      count: '112 gift ideas',
      color: 'from-[#1B4332] to-[#2D5F4C]',
      bgColor: 'bg-gradient-to-br from-[#1B4332]/5 to-[#2D5F4C]/10'
    },
    { 
      name: 'Luxury Gifts', 
      icon: 'ri-vip-crown-fill', 
      count: '76 gift ideas',
      color: 'from-[#D4AF37] to-[#8B2635]',
      bgColor: 'bg-gradient-to-br from-[#D4AF37]/5 to-[#8B2635]/10'
    }
  ];

  return (
    <section className="py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div 
          ref={titleRef}
          className={`text-center mb-16 transition-all duration-700 ${
            titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1B4332] mb-4">
            Shop by Category
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Browse our expertly curated gift collections to find the perfect present for everyone on your list
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {categories.map((category, index) => (
            <Link
              key={index}
              to="/gift-guides"
              className={`${category.bgColor} rounded-3xl p-8 card-festive group cursor-pointer transition-all duration-500 ${
                gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: `${index * 80}ms` }}
            >
              <div className={`w-28 h-28 mx-auto mb-6 rounded-full bg-gradient-to-br ${category.color} flex items-center justify-center group-hover:rotate-12 group-hover:scale-110 transition-all duration-500 border-4 border-white shadow-lg relative overflow-hidden`}>
                <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-shimmer"></div>
                <i className={`${category.icon} text-5xl text-white relative z-10 group-hover:scale-110 transition-transform duration-300`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1B4332] text-center mb-2 group-hover:text-[#8B2635] transition-colors duration-300">
                {category.name}
              </h3>
              <p className="text-gray-600 text-center text-sm group-hover:text-gray-800 transition-colors">{category.count}</p>
              <div className="mt-4 flex justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
                <span className="text-[#8B2635] font-medium flex items-center gap-1">
                  Explore <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
